export default "__VITE_ASSET__ecid9aAH__"